import {
	getRiskTemplateCatalog,
	getRiskTemplateCatalogResolved,
	getRiskTemplateCatalogRejected,
} from '@Actions/RiskTemplateCatalog.actions';
import { createReducer } from '@reduxjs/toolkit';
import { RiskTemplateCatalogStoreState } from '@Types/riskTemplateCatalog.types';
import { AnyAction } from 'redux';

export const initState: RiskTemplateCatalogStoreState = {
	status: 'idle',
	templates: [],
};

interface RiskTemplateCatalogReducer {
	[x: string]: (
		state: RiskTemplateCatalogStoreState,
		action: AnyAction,
	) => RiskTemplateCatalogStoreState;
}

export const reducer: RiskTemplateCatalogReducer = {
	[getRiskTemplateCatalog.toString()]: state => ({
		...state,
		status: 'loading',
		templates: [],
	}),
	[getRiskTemplateCatalogResolved.toString()]: (state, action) => ({
		...state,
		status: 'loaded',
		templates: action.payload,
	}),
	[getRiskTemplateCatalogRejected.toString()]: state => ({
		...state,
		status: 'error',
		templates: [],
	}),
};

export const riskTemplateCatalogReducer = createReducer(initState, reducer);
